import { css, styled } from "@mui/material";
import { ChevronRight } from "@procore/core-icons";
import { colors } from "@procore/core-react";

import { CHEVRON_SIZE } from "../constants";

interface TreeNodeChevronProps {
    isExpanded: boolean;
    onToggle: () => void;
}

const ChevronButton = styled("button", {
    shouldForwardProp: (prop) => prop !== "isExpanded",
})<{ isExpanded: boolean }>(
    ({ isExpanded }) => css`
        height: ${CHEVRON_SIZE}px;
        width: ${CHEVRON_SIZE}px;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 0;
        border: none;
        background: none;
        cursor: pointer;
        transform: ${isExpanded ? "rotate(90deg)" : "rotate(0deg)"};
        transition: transform 0.2s ease;
        border-radius: 4px;
        flex-shrink: 0;

        @media (hover: hover) and (pointer: fine) {
            &:hover {
                background-color: ${colors.gray90};
            }
        }
    `,
);

export function TreeNodeChevron({ isExpanded, onToggle }: TreeNodeChevronProps) {
    return (
        <ChevronButton
            isExpanded={isExpanded}
            onClick={(e) => {
                e.stopPropagation();
                onToggle();
            }}
        >
            <ChevronRight style={{ color: colors.gray60 }} />
        </ChevronButton>
    );
}
